import { createReducer } from '../../utils';
import types from './types';

// TODO Change naming
export const initialState = {
    successOverlay: null,
    // The parameters are to give more info to successOverlays.
    params: {
        doi: { // TODO Do we need this nesting?
            emailProvider: null,
            sendingConfirmationEmail: false,
        },
    },
    // This is for errors/success messages.
    // I need it splitted from general flashmessenger
    // because it's out of sight and fixing that requires a lot of refactoring
    alert: null
};

const ACTION_HANDLERS = {
    [types.SO_SET_SUCCESS_OVERLAY]: (state, { payload: { successOverlay } }) => ({
        ...state,
        successOverlay
    }),

    [types.SO_SET_PARAM_MAIL_PROVIDER]: (state, { payload: { emailProvider } }) => ({
        ...state,
        params: {
            ...state.params,
            doi: {
                ...state.params.doi,
                emailProvider
            }
        },
    }),

    [types.SO_SET_PARAM_SEND_CONFIRMATION_EMAIL]: (state, { payload: { sendingConfirmationEmail } }) => ({
        ...state,
        params: {
            ...state.params,
            doi: {
                ...state.params.doi,
                sendingConfirmationEmail
            }
        },
    }),

    [types.SO_SET_ALERT]: (state, { payload: { type, message } }) => ({
        ...state,
        alert: {
            type,
            message,
        },
    }),

    [types.SO_CLEAR_ALERT]: state => ({
        ...state,
        alert: null,
    }),
};

export default createReducer(ACTION_HANDLERS, initialState);
